import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd/lib/grid';
import Text, { FontFamilyVariant, TextType } from '@components/Text';
import { translate } from "@translations/Translater";
import { PlaceholderImage } from '@assets/images';
import { WF_Logo_Color } from '@assets/index';

import WFImg from '@components/atoms/Image/Img';

import './styles.less';
import { dashboardMessages } from '@containers/Dashboard/messages';

interface IProps {
    image: string;
    children: any;
    className?: string;
    formContainerStyle?: string;
    showLogo?: boolean;
    showText?: boolean;
}
export default function RegistrationForm(props: IProps) {
    const { image, children, className, formContainerStyle, showLogo = true, showText } = props;
    const { t } = useTranslation();
    return (
        <Row className={`reg_form__container ${formContainerStyle}`}>
            <Col
                className="reg_form__left_container"
                md={11}
                xs={24}
            >
                <WFImg alt="registration-form-placeholder" className="reg_form__image" placeholder={PlaceholderImage} src={image} />
                {showText && <div className='reg_form__image_disclaimer'>
                    <Text
                        textType={TextType.h8}
                        fontFamilyVariant={FontFamilyVariant.bold}
                        className={"image_disclaimer_heading"}
                        text={translate(t, dashboardMessages.unlockPremiumFeatureHeading)}
                    />
                    <Text
                        textType={TextType.h8}
                        fontFamilyVariant={FontFamilyVariant.regular}
                        className={"image_disclaimer_description"}
                        text={translate(t, dashboardMessages.unlockPremiumFeatureDescription)}
                    />
                </div>}
            </Col>
            <Col md={1} xs={0} />
            <Col
                className={`reg_form__right_container ${className}`}
                md={11}
                xs={24}
            >
                {showLogo && <WFImg alt="logo" className="app_logo" src={WF_Logo_Color} />}
                <div className="form_holder">
                    <div className="form_center">
                        {children}
                    </div>
                </div>
                {showText && <div className='reg_form__image_disclaimer'>
                    <Text
                        textType={TextType.h8}
                        fontFamilyVariant={FontFamilyVariant.bold}
                        className={"image_disclaimer_heading"}
                        text={translate(t, dashboardMessages.unlockPremiumFeatureHeading)}
                    />
                    <Text
                        textType={TextType.h8}
                        fontFamilyVariant={FontFamilyVariant.regular}
                        className={"image_disclaimer_description"}
                        text={translate(t, dashboardMessages.unlockPremiumFeatureDescription)}
                    />
                </div>}
            </Col>
            <Col md={1} xs={0} />

        </Row>
    );
}
